import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { call } from "@redux-saga/core/effects";
import { queryClient } from "../../store";

export type GetClientIdentifiersLoadAction = {
  type: string;
};

export type GetClientIdentifiersData = {
  data: {
    ip:string;
    ray_id:string;
  };
};

const GetClientIdentifiers = new ReduxFetchState<
  GetClientIdentifiersData | null,
  any
>("getClientIdentifiers");

export function* watchGetClientIdentifiers(action: GetClientIdentifiersLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetClientIdentifiersData = yield call([queryClient, queryClient.fetchQuery], {
      queryKey: ["getClientIdentifiers", lang],
      queryFn: async () => {
        const res = await axios({
          url: `/api/v1/users/client-identifiers`,
          method: "GET",
          headers: { lang },
        });
        return { data: res.data };
      },
      staleTime: 1440 * 60 * 1000,
    });

    yield put(GetClientIdentifiers.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    yield put(GetClientIdentifiers.actions.loadFailure(e?.response?.data));
  }
}

export function* getClientIdentifiersSagas() {
  yield takeEvery(GetClientIdentifiers.actionTypes.load, watchGetClientIdentifiers);
}

export function useGetClientIdentifiers() {
  const { loading, data, ...getClientIdentifiersState } = useAppSelector((state) => state.getClientIdentifiers);
  const dispatch = useAppDispatch();

  const dispatchGetClientIdentifiers = useCallback(
    () => {
      dispatch(GetClientIdentifiers.actions.load());
    },
    [dispatch],
  );

  return {
    ...getClientIdentifiersState,
    dispatchGetClientIdentifiers,
    getClientIdentifiersLoading: loading,
    getClientIdentifiersData: data,
  };
}

export const {
  actionTypes: getClientIdentifiersActionsTypes,
  actions: getClientIdentifiersActions,
  reducer: getClientIdentifiersReducer,
} = GetClientIdentifiers;